/**
 * A small dot with a ring breathing out of it — the "this is live, act on it"
 * cue used on open votes.
 *
 * Three stacked circles: a halo that swells and fades, a ring that scales up
 * and fades out of it, and the lit core itself. The keyframes live in
 * index.css and respect prefers-reduced-motion. The ring takes the colour
 * class so it works on paper and on ink; the core and halo are the same mint
 * either way, because the point of them is to look lit.
 */
export const LiveDot = ({
  color = "bg-vote-yes",
  size = 7,
}: {
  color?: string;
  size?: number;
}) => (
  <span className="relative flex-shrink-0" style={{ width: size, height: size }} aria-hidden>
    <span className={`absolute inset-0 rounded-full dss-ping ${color}`} />
    <span className="absolute inset-0 rounded-full dss-livedot-halo" />
    <span className={`absolute inset-0 rounded-full dss-livedot-core ${color}`} />
  </span>
);

export default LiveDot;
